/**
 * HNB-575 — Product-card media hit targets use data-href (not <a>, not onclick)
 * so WAVE does not flag Redundant link / Device-dependent event handler.
 * Keyboard/AT users use the info link in the card.
 */
(function () {
  if (window._mfrA11yProductCardMedia) return;
  window._mfrA11yProductCardMedia = true;

  document.addEventListener(
    'click',
    function (event) {
      var el = event.target && event.target.closest
        ? event.target.closest('.product-card__media-link[data-href]')
        : null;
      if (!el) return;
      var href = el.getAttribute('data-href');
      if (!href) return;
      window.location.href = href;
    },
    false
  );
})();
